import { useField } from 'react-final-form';
import * as R from 'ramda';

function useFieldValue(name) {
  const field = useField(name);
  return R.path(['input', 'value'], field);
}

export default useFieldValue;
